const Style = {

  base: 'inline-flex items-center ml-1 no-underline opacity-60 hover:opacity-100',

}

export default Style;
